export default __webpack_public_path__ + "static/media/desktop_79.49ebb149.jpg";